import http from "../request";

export interface Apply {
  id: number;
  temple_id: number;
  user_id: string;
  temp_id: number;
  detail: string;
  status: number;
  flow_status?: string;
  confirm_info?: string;
  temp_snap?: string;
  real_flow?: string;
  temp_flow_snap: string;
  evaluate: number;
  extra_apply?: string;
  extra_apply_ids?: string;
  sign?: string;
  select?: string;
  export_detail?: string;
  create_time: string;
  update_time: string;
}

export interface ApplyApi {
  getApplyById: (id: number) => Promise<Apply>;
}

const applyApi: ApplyApi = {
  getApplyById(id) {
    return http.get<Apply>("/apply/" + id).then((res) => res.data);
  },
};

export default applyApi;
